<h2 mat-dialog-title>Reschedule appointment</h2>

<mat-dialog-content class="reschedule-confirm">
    <p class="patient">{{ data.patientName }}</p>
    <div class="move">
        <span class="from">{{ data.from }}</span>
        <mat-icon>arrow_forward</mat-icon>
        <span class="to">{{ data.to }}</span>
    </div>
    <p class="warning" *ngIf="data.slotFull">
        <mat-icon>warning</mat-icon>
        This slot is already full.
    </p>
    <mat-slide-toggle *ngIf="data.canNotify" color="primary" [(ngModel)]="notifyPatient">
        Notify this patient about the change
    </mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" (click)="confirm()">Reschedule</button>
</mat-dialog-actions>
